import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AdminDashboardPage from './dashboard';
import SiteListPage from './sites/list/SiteListPage';
import EditSitePage from './sites/edit';
import CreateSitePage from './sites/create';
import ChangeSitePasswordPage from './sites/changePassword';
import UpdateLicensePage from './updateLicense';
import SitePosterPage from './sites/poster';
import { BadgeGeneratorPage, BadgeUsagePage } from './badges';
import {
  VisitorTypeListPage,
  CreateVisitorTypePage,
  EditVisitorTypePage,
} from './visitorTypes';
import {
  VisitorAgreementListPage,
  CreateVisitorAgreementPage,
  EditVisitorAgreementPage,
} from './visitorAgreements';
import {
  QuestionnaireListPage,
  CreateQuestionnairePage,
  EditQuestionnairePage,
} from './questionnaire';
import { ThemeListPage, CreateThemePage, EditThemePage } from './theme';
import { EditSettingsPage } from './settings';
import NotFoundPage from '../routes/notFound';
import UnderConstructionPage from '../routes/underConstruction';

const AdminRoutes: React.FC = () => (
  <Switch>
    <Route
      path="/admin/password"
      render={() => <ChangeSitePasswordPage siteAdminPassword />}
    />
    <Route path="/admin/license" component={UpdateLicensePage} />
    <Route path="/admin/help" component={UnderConstructionPage} />
    <Route path="/admin/badges/create" component={BadgeGeneratorPage} />
    <Route path="/admin/badges/usage" component={BadgeUsagePage} />
    <Route path="/admin/themes/create" component={CreateThemePage} />
    <Route path="/admin/themes/:id" component={EditThemePage} />
    <Route path="/admin/themes" component={ThemeListPage} />
    <Route path="/admin/settings" component={EditSettingsPage} />
    <Route
      path="/admin/visitorTypes/create"
      component={CreateVisitorTypePage}
    />
    <Route path="/admin/visitorTypes/:id" component={EditVisitorTypePage} />
    <Route path="/admin/visitorTypes" component={VisitorTypeListPage} />
    <Route
      path="/admin/questionnaires/create"
      component={CreateQuestionnairePage}
    />
    <Route path="/admin/questionnaires/:id" component={EditQuestionnairePage} />
    <Route path="/admin/questionnaires" component={QuestionnaireListPage} />

    <Route path="/admin/sites/:pin/poster" component={SitePosterPage} />
    <Route path="/admin/sites/create" component={CreateSitePage} />
    <Route
      path="/admin/sites/:pin/password"
      component={ChangeSitePasswordPage}
    />
    <Route path="/admin/sites/:pin" component={EditSitePage} />
    <Route path="/admin/sites" component={SiteListPage} />
    <Route
      path="/admin/visitorAgreements/create"
      component={CreateVisitorAgreementPage}
    />
    <Route
      path="/admin/visitorAgreements/:id"
      component={EditVisitorAgreementPage}
    />
    <Route
      path="/admin/visitorAgreements"
      component={VisitorAgreementListPage}
    />
    <Route path="/admin" component={AdminDashboardPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default AdminRoutes;
